import React from 'react';
import { localizeAccordionItems } from '../../utils/lexiconReact';
import { useLexicon } from '../../hooks/useLexicon';
import {
  MainContainer,
  HowJeddAiWorksVideo,
  FAQSection,
  FAQHeading,
  FAQContent,
} from './whatIsJeddAiStyle.js';
import MaterialAccordion from '../MaterialAccordion/index.jsx';
import { accordionItems } from './OnboardingAccordionItems.js';

const WhatIsJeddAi = () => {
  const { lt } = useLexicon();
  const localizedItems = localizeAccordionItems(accordionItems, lt);
  return (
    <MainContainer>
      <HowJeddAiWorksVideo
        data-dd-privacy="hidden"
        src="https://fast.wistia.net/embed/iframe/pas1z2rcol"
        frameborder="0"
        allowfullscreen
      ></HowJeddAiWorksVideo>
      <FAQSection>
        <FAQHeading>FAQ's</FAQHeading>
        <FAQContent>
          <MaterialAccordion accordionList={localizedItems} />
        </FAQContent>
      </FAQSection>
    </MainContainer>
  );
};

export default WhatIsJeddAi;
